import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Row, Container, Form, Spinner } from "react-bootstrap";
import img from "./images/logo.png";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Switch, Route, Link, useHistory } from "react-router-dom";
import IfcContainer from "./IfcContainer.js";
import MapL from "./Map.js";
import imgHeader from "./images/header-background.png";
import euLogo from "./images/eu-logo.png";

function App(props) {
  let history = useHistory();
  let [activeSpinner, setActiveSpinner] = useState(true);
  useEffect(() => {
    axios.get("/validate").then((resp) => {
      setActiveSpinner(false);
      if (resp.data != "ok") history.push("/unauthorized");
    });
  }, []);
  return (
    <React.Fragment>
      <div id="mainContainer">
        <Container fluid id="internalContainer">
          <Switch>
            <Route
              path="/pilotcase1"
              component={() => (
                <IfcContainer
                  ifcFile="/NEW_WING_MODEL.ifc"
                  title="nZEB Smart House DIH in Thessaloniki Greece"
                />
              )}
            />
            <Route
              path="/pilotcase2"
              component={() => (
                <IfcContainer
                  ifcFile="/CaseStudy2.ifc"
                  title="ResidentialMulti-family building in Velten Germany"
                />
              )}
            />
            <Route
              path="/pilotcase3"
              component={() => (
                <IfcContainer
                  ifcFile="/CaseStudy3.ifc"
                  title="Tertiary buildingOffices in Berlin Germany"
                />
              )}
            />
            <Route
              path="/pilotcase4"
              component={() => (
                <IfcContainer
                  ifcFile="/SmartHomeV2.ifc"
                  title="Mixed-use building in Nicosia Cyprus"
                />
              )}
            />
            <Route
              path="/pilotcase5"
              component={() => (
                <IfcContainer
                  ifcFile="/Velten building model RTE23_29.08.ifc"
                  title="Multi-family home in Berlin Germany"
                />
              )}
            />
            <Route
              path="/pilotcase6"
              component={() => (
                <IfcContainer
                  ifcFile="/FRC_changes.ifc"
                  title="Multi-family home in Berlin Germany."
                />
              )}
            />
            <Route path="/" render={() => <MapL />}></Route>
          </Switch>
        </Container>
      </div>

      <div id="footerContainer">
        <Container fluid>
          <Row>
            <Col xs="auto" style={{ width: "2.5rem" }}>
              {" "}
            </Col>
            <Col xs="auto" className="flex-grow-1">
              <Row>
                <Col
                  xs={1}
                  style={{
                    height: "7vh",
                    lineHeight: "6vh",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <img style={{ height: "5vh" }} src={euLogo} />
                </Col>
                <Col xs={9} style={{ height: "7vh", marginLeft: "-50px" }}>
                  This project has received funding from the European Union’s
                  Horizon 2020 research and innovation programme under <br />{" "}
                  grant agreement No. 892984.
                </Col>
                <Col
                  xs={2}
                  style={{
                    textAlign: "center",
                    lineHeight: "7vh",
                    fontSize: "15px",
                  }}
                >
                  {" "}
                  <a
                    style={{ color: "#8c8c8c" }}
                    href="https://www.d2epc.eu/en"
                  >
                    {" "}
                    www.d2epc.eu{" "}
                  </a>{" "}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      {activeSpinner ? (
        <div id="spinDiv">
          <Spinner animation="border" />
        </div>
      ) : null}
    </React.Fragment>
  );
}

export default App;
